export default "__VITE_ASSET__CD5PTZ1z__"